import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { Description as DescriptionType } from '@application/Types/ComponentTypes'

import { Description, Title, Wrapper } from './Card.styled'

type CardProps = {
    title: string
    description: DescriptionType
    className?: string
}
export const Card = ({ title, description, className }: CardProps): JSX.Element => {
    return (
        <Wrapper className={className}>
            <Title>{title}</Title>
            <Description>
                <Html content={description.data.childMarkdownRemark.html} />
            </Description>
        </Wrapper>
    )
}
